import "unpoly/unpoly.js";
import Choices from "choices.js";
import startAnalytics from "../custom_js/start_analytics.js";
import Alpine from "alpinejs";

import "../up_compiler/happening/up_happening_filter_date.js";
import "../up_compiler/happening/up_happening_filter_fresk.js";
import "../up_compiler/manage_workshops/up_billing/up_toggle_prez.js";
import "../up_compiler/manage_workshops/up_billing/up_license.js";
import "../up_compiler/manage_workshops/up_billing/up_not_below_zero.js";
import "../up_compiler/manage_workshops/up_billing/up_billing.js";
import "../up_compiler/manage_workshops/up_billing/up_city_billing.js";
import "../up_compiler/manage_workshops/up_billing/up_cancel.js";
import "../up_compiler/manage_workshops/up_billing/up_public.js";
import "../up_compiler/manage_workshops/up_copy_tooltip.js";
import "../up_compiler/manage_workshops/up_phone_number.js";
import "../up_compiler/manage_workshops/up_delete_workshop.js";
import "../up_compiler/manage_workshops/up_delete_participant.js";
import "../up_compiler/manage_workshops/up_sortby_price.js";
import "../up_compiler/manage_workshops/up_sortby_date.js";
import "../up_compiler/manage_workshops/up_sortby_participant.js";
import "../up_compiler/manage_workshops/up_qcity.js";
import "../up_compiler/manage_workshops/up_qcust.js";
import "../up_compiler/manage_workshops/up_qname.js";
import "../up_compiler/manage_workshops/up_qremote.js";
import "../up_compiler/manage_workshops/up_qfact.js";
import "../up_compiler/manage_workshops/up_qpro.js";
import "../up_compiler/manage_workshops/up_qtiming.js";
import "../up_compiler/manage_workshops/up_qcible.js";
import "../up_compiler/manage_workshops/up_modify_hours.js";
import "../up_compiler/manage_workshops/up_harvest.js";
import "../up_compiler/manage_workshops/up_invite_part.js";
import "../up_listener/link_spinner.js";
import "../up_listener/listen_fragment_inserted.js";
import "../up_compiler/up_remove_workshopper.js";
import "../up_compiler/up_add_workshopper.js";
import "../up_compiler/up_searchstatus.js";
import "../up_compiler/up_searchcity.js";
import "../up_compiler/up_manageshow.js";
import "../up_compiler/up_recontact.js";
import "../up_compiler/up_toast.js";
import "../up_compiler/up_risky.js";
import "../up_compiler/up_animator_tr.js";
import "../up_compiler/up_workshop_tr.js";
import "../up_compiler/up_blog.js";
import "../up_compiler/up_toggle.js";
import "../up_compiler/up_link_copied.js";
import "../up_compiler/up_sizeable_figure.js";
import "../up_compiler/up_search_fresk.js";
import "../up_compiler/select_ftag.js";
import "../up_compiler/home/up_filter_city.js";
import "../up_compiler/home/up_filter_industry.js";
import "../up_compiler/home/up_filter_fresk.js";
import "../up_compiler/up_select_fresk_recontacting.js";
import "../up_compiler/up_clear_placeholder.js";
import "../up_compiler/select_fresk_animation.js";
import "../up_compiler/select_month_animation.js";
import "../up_compiler/select_city_animation.js";
import "../up_compiler/select_expertise_animation.js";
import "../up_compiler/select_othercities_animation.js";

// Define and start analytics
startAnalytics(up);

// Still needed for the navbar
window.Alpine = Alpine;
Alpine.start();

// Improve selectbox globally
window.Choices = Choices;

// config links for Unpoly
up.link.config.followSelectors.push("a[href]");
up.link.config.preloadSelectors.push("a[href]");

// config forms for Unpoly
up.form.config.submitSelectors.push("form");
up.link.config.instantSelectors.push("a[href]");

// disable/enable logs for Unpoly
up.log.disable();
